import { render, staticRenderFns } from "./MpLabel.vue?vue&type=template&id=34999dda&scoped=true"
import script from "./MpLabel.vue?vue&type=script&lang=js"
export * from "./MpLabel.vue?vue&type=script&lang=js"
import style0 from "./MpLabel.vue?vue&type=style&index=0&id=34999dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34999dda",
  null
  
)

export default component.exports